"use client";

import Logo from "./Logo";
import Notice from "./Notice";
import Button from "./Button";
import { worldReviewScreen } from "../worlds/registry";
import { AccountView } from "@/lib/types";

/** 選ばれた世界のキャラクター確認画面を出す */
export default function WorldReviewScreen({
  world,
  region,
  slug,
  account,
  onBack,
  onDone,
}: {
  world: string;
  region: string;
  slug: string;
  account: AccountView;
  onBack: () => void;
  onDone: (account?: AccountView) => void;
}) {
  const Screen = worldReviewScreen(world);

  if (Screen) {
    return <Screen region={region} slug={slug} account={account} onBack={onBack} onDone={onDone} />;
  }

  return (
    <div className="panel">
      <Logo />
      <Notice>
        <p>{world} のキャラクター確認画面は未実装です。</p>
      </Notice>
      <div className="foot">
        <Button onClick={onBack} inline>
          戻る
        </Button>
      </div>
    </div>
  );
}
